<template>
  <div class="pc-box">
    <iframe class="pc" src="/?pc=1" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  name: "pc",
};
</script>

<style lang="scss" scoped>
.pc-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  .pc {
    width: 375px;
    height: 667px;
  }
}
</style>
